import type { App } from '@grafikr/components';

import Cart from 'utils/cart';

export default ({ context }: App) => {
  const getCart = () => {
    Cart.get({
      success: (body) => {
        theme.cart = body;

        context.dispatchEvent('cart:fetched', body);
      },
    });
  };

  document.addEventListener('cart:added', getCart);
  document.addEventListener('cart:updated', getCart);
};
